import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './GoldenEggs.less';

export default class GoldenEggs extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '参与活动赢大奖'
    },
    activityId: '', //活动号
    goldenData: {}, //活动信息
    winnerList: [], //中奖名单
    exchangeMessage: {}, //兑换次数信息
    isExchange: 0, //是否关闭兑换次数弹窗
    isRecord: 0, //是否关闭查看奖品弹窗
    eggsList: [
      {
        hasAnimate: false
      },
      {
        hasAnimate: false
      },
      {
        hasAnimate: false
      }
    ],
    comfort: 0, //是否显示安慰奖弹窗
    prizeFail: 0, //是否显示未中奖弹窗
    congratulation: 0, //是否显示中奖弹窗
    eggNum: '', //砸蛋次数
    isdegree: 0, //次数用尽不可分享
    duraMax: 0, //次数用尽可分享
    isPlay: false, //音乐是否播放
    inputValue: '', //兑换次数
    myPrize: [], //我的奖品记录
    isSinker: false,
    isWin: false, //是否中奖
    animationData: {}, //中奖名单动画
    animationData2: {},
    franchisee: '',
    ifWxCoupon: false,
    timestamp: '',
    signature: '',
    ifGetComfort: false,
    isShare: false
  }

  constructor(props) {
    super(props);
    document.title = '砸金蛋';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this,
      id = that.data.goldenData.id
    let franchisee = options.franchisee || ''
    this.setData({
      franchisee: franchisee,
      shareKey: options.shareKey || ''
    })
    if (app.isLogin()) {
      that.getGoldenInfo()
    } else {
      app.goLogin({
        success: function () {
          that.getGoldenInfo()
        },
        fail: function () {
          app.turnBack()
        }
      })
    }
    this.animation = app.createAnimation({
      duration: 0,
      timingFunction: 'step-start'
    })
    this.animation2 = app.createAnimation({
      duration: 0,
      timingFunction: 'step-start'
    })
  }

  componentWillUnmount() {
    let that = this
    clearTimeout(that.timeer)
    clearTimeout(that.timeer2)
    clearTimeout(that.timeer3)
    clearTimeout(that.timeer4)
  }

  getGoldenInfo = () => {
    let that = this,
      dataObj = new Object()
    dataObj['category'] = 2
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getActivity',
      method: 'post',
      data: dataObj,
      success: function (res) {
        let mes = res.data
        mes.description = mes.description.replace(/\\n/g, '\n')
        that.setData({
          goldenData: mes,
          eggNum: mes.times
        })
        app.setNavigationBarTitle({
          title: mes.title
        })
        // TODO
        // that.audioCtx = app.createAudioContext('goldenAudio')
        // if (mes.bgm != 0) {
        //   that.audioCtx.play()
        // } else {
        //   that.audioCtx.pause()
        // }
        that.getWinnerList(that.data.goldenData.id)
        if (that.data.shareKey) {
          that.getTimeByShareKey(that.data.goldenData.id, that.data.shareKey)
        }
        that.getShareKey(that.data.goldenData.id)
      }
    })
  }
  getShareKey = id => {
    var that = this,
      dataObj = new Object()
    dataObj['activity_id'] = id
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getShareKey',
      data: dataObj,
      success: function (res) {
        var data = res
        if (data.status == 0) {
          that.setData({
            shareKey: data.data
          })
        }
      }
    })
  }
  getTimeByShareKey = (id, shareKey) => {
    var that = this,
      dataObj = new Object()
    dataObj['activity_id'] = id
    dataObj['share_key'] = shareKey
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeByShareKey',
      data: dataObj,
      success: function (res) { }
    })
  }
  getWinnerList = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getWinnerList',
      method: 'post',
      hideLoading: true,
      data: {
        activity_id: id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        let winHeight = (res.count + 5) * 44
        that.setData({
          winnerList: res.data
        })
        that.animationTop(winHeight, true)
      }
    })
  }
  getMyIntegral = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getMyIntegralExchangeTimes',
      method: 'post',
      data: {
        activity_id: that.data.goldenData.id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          exchangeMessage: res.data
        })
      }
    })
  }
  exchangePrizeClick = () => {
    let that = this
    that.getMyIntegral()
    that.setData({
      isExchange: 1
    })
  }
  exchangeCancel = () => {
    this.setData({
      isExchange: 0
    })
  }
  recordClick = () => {
    let that = this
    that.setData({
      isRecord: 1
    })
    that.getMyPrize()
  }
  recordWrapClick = () => {
    this.setData({
      isRecord: 0
    })
  }
  stopPropagation = () => { }
  startEgg = event => {
    let that = this
    let index = event.currentTarget.dataset.index
    if (!that.data.goldenData.id) {
      return
    }
    if (that.eggsLoading) {
      return
    }
    that.eggsLoading = true
    if (that.data.eggNum <= 0) {
      if (that.data.goldenData.time_share == 0) {
        that.setData({
          isdegree: 1
        })
      } else {
        that.setData({
          duraMax: 1
        })
      }
      that.eggsLoading = false
      return
    } else {
      that.eggsClick(index)
    }
    that.setData({
      isSinker: true
    })
  }
  eggsLoading = false
  eggsClick = index => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      method: 'post',
      hideLoading: true,
      data: {
        activity_id: that.data.goldenData.id,
        app_id: app.globalData.appId,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        let data = res.data
        let newdata = {}
        if (data.title == '谢谢参与') {
          newdata['isWin'] = false
          setTimeout(function () {
            newdata = {}
            newdata['eggsList[' + index + '].hasAnimate'] = false
            newdata['prizeFail'] = 1
            that.setData(newdata)
            that.eggsLoading = false
          }, 2200)
        } else {
          newdata['isWin'] = true
          setTimeout(function () {
            newdata = {}
            if (data.is_comfort == 1) {
              newdata['comfort'] = 1
            } else {
              newdata['congratulation'] = 1
              newdata['prize_title'] = data.title
            }
            let ifWxCoupon = data.card_id || false
            newdata['ifWxCoupon'] = ifWxCoupon
            newdata['timestamp'] = data.timestamp || ''
            newdata['signature'] = data.signature || ''
            newdata['eggsList[' + index + '].hasAnimate'] = false
            that.setData(newdata)
            that.eggsLoading = false
            if (ifWxCoupon) {
              that.toAddCard()
            }
          }, 2200)
          if (!that.data.ifWxCoupon) {
            that.getWinnerList(that.data.goldenData.id)
          }
        }
        newdata.eggNum = that.data.eggNum - 1
        newdata['eggsList[' + index + '].hasAnimate'] = true
        that.setData(newdata)
      },
      successStatusAbnormal: function () {
        that.eggsLoading = false
      }
    })
  }
  notwinningClick = () => {
    this.setData({
      prizeFail: 0
    })
  }
  confirmClick = () => {
    this.setData({
      congratulation: 0
    })
  }
  duraClick = () => {
    this.setData({
      duraMax: 0
    })
  }
  comfortClick = () => {
    this.setData({
      comfort: 0,
      ifGetComfort: false
    })
  }
  degreeClick = () => {
    this.setData({
      isdegree: 0
    })
  }
  onShareAppMessage = res => {
    this.setData({
      isShare: true
    })
    var that = this
    that.getShareKey(that.data.goldenData.id)
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    return app.shareAppMessage({
      title: that.data.goldenData.title,
      path:
        '/awardManagement/pages/goldenEggs/goldenEggs?id=' +
        that.data.activityId +
        '&shareKey=' +
        that.data.shareKey +
        franchiseeParam,
      success: function (res) {
        if (that.data.ifWxCoupon) {
          return
        }
        that.setData({
          prizeFail: 0,
          duraMax: 0,
          congratulation: 0
        })
      },
      fail: function (res) { },
      complete: function () {
        that.setData({
          isShare: false
        })
      }
    })
  }
  playMusics = () => {
    if (this.data.goldenData.bgm) {
      if (this.data.isPlay) {
        this.audioCtx.pause()
      } else {
        this.audioCtx.play()
      }
    } else {
      app.showToast({
        title: '活动未开始，没有音乐',
        icon: 'none'
      })
    }
  }
  audioPlay = () => {
    this.setData({
      isPlay: true
    })
  }
  audioPause = () => {
    this.setData({
      isPlay: false
    })
  }
  bindReplaceInput = e => {
    this.setData({
      inputValue: e.target.value
    })
  }
  exchangeAll = () => {
    let that = this
    that.setData({
      inputValue: that.data.exchangeMessage.exchange_times
    })
  }
  exchangeConfirm = () => {
    let that = this
    if (that.data.goldenData.id) {
      that.getIntegralTime()
    }
  }
  getIntegralTime = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTime',
      method: 'post',
      data: {
        activity_id: that.data.goldenData.id,
        type: 'integral',
        times: that.data.inputValue,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          eggNum: res.data,
          isExchange: 0,
          inputValue: ''
        })
      }
    })
  }
  getMyPrize = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getMyPrize',
      method: 'post',
      data: {
        activity_id: that.data.goldenData.id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          myPrize: res.data
        })
      }
    })
  }
  animation = ''
  animation2 = ''
  animationTop = (h, isreset) => {
    var that = this
    var $winnerList1 = document.querySelector('.winner-list1');
    clearTimeout(that.timeer)
    clearTimeout(that.timeer2)
    if (isreset) {
      // that.animation
      //   .top('190rpx')
      //   .step({ duration: 0, timingFunction: 'step-start' })
      // that.animation2
      //   .top('190rpx')
      //   .step({ duration: 0, timingFunction: 'step-start' })

      // that.setData({
      //   animationData: that.animation.export(),
      //   animationData2: that.animation2.export()
      // })
      setTimeout(function () {
        that.animation
          .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
          .step({ duration: 15000, timingFunction: 'linear' })
        // that.setData({
        //   animationData: that.animation.export()
        // })
        $winnerList1.animate(that.animation.keyframes, that.animation.options);
        that.animationTopCopy(h, isreset)
      }, 50)
    } else {
      that.timeer = setTimeout(function () {
        // that.animation
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   animationData: that.animation.export()
        // })
      }, (200 / (h + 200)) * 15000)
      that.timeer2 = setTimeout(function () {
        that.animation
          .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
          .step({ duration: 15000, timingFunction: 'linear' })
        // that.setData({
        //   animationData: that.animation.export()
        // })
        $winnerList1.animate(that.animation.keyframes, that.animation.options);
        that.animationTopCopy(h)
      }, (h / (h + 200)) * 15000)
    }
  }
  animationTopCopy = (h, isreset) => {
    var that = this
    var $winnerList2 = document.querySelector('.winner-list2');
    clearTimeout(that.timeer3)
    clearTimeout(that.timeer4)
    if (!isreset) {
      that.timeer3 = setTimeout(function () {
        // that.animation2
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   animationData2: that.animation2.export()
        // })
      }, (200 / (h + 200)) * 15000)
    }
    that.timeer4 = setTimeout(function () {
      that.animation2
        .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
        .step({ duration: 15000, timingFunction: 'linear' })
      $winnerList2.animate(that.animation.keyframes, that.animation.options);
      // that.setData({
      //   animationData2: that.animation2.export()
      // })
      that.animationTop(h)
    }, (h / (h + 200)) * 15000)
  }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      _this = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function (res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: true
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            sub_app_id: _data.franchisee,
            activity_id: _data.goldenData.id,
            app_id: _data.goldenData.app_id
          },
          success: function (res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
            _this.getWinnerList(_this.data.goldenData.id)
          }
        })
      }
    })
  }
  shadeClose = () => {
    if (this.data.isShare) {
      return
    }
    let _this = this,
      ifWxCoupon = _this.data.ifWxCoupon
    if (ifWxCoupon) {
      app.showModal({
        title: '提示',
        content:
          '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
        showCancel: true,
        confirm: function (res) {
          _this.setData({
            congratulation: 0,
            comfort: 0,
            ifWxCoupon: false,
            ifGetComfort: false
          })
        }
      })
    } else {
      this.setData({
        congratulation: 0,
        comfort: 0,
        ifGetComfort: false
      })
    }
  }

  render() {
    const {
      showGetUserInfo,
      topNavBarData,
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      goldenData,
      isPlay,
      isSinker,
      eggsList,
      isWin,
      eggNum,
      winnerList,
      animationData,
      animationData2,
      exchangeMessage,
      inputValue,
      isExchange,
      myPrize,
      isRecord,
      duraMax,
      isdegree,
      prize_title,
      ifWxCoupon,
      congratulation,
      prizeFail,
      ifGetComfort,
      comfort
    } = this.state
    return (
      <React.Fragment>
        <div className="official-page golden-eggs">
          <TopNav title="砸金蛋" />
          <div className="page" id="goldenEggs">
            {/* TODO {goldenData.bgm != 0 && (
              <Audio
                id="goldenAudio"
                src={goldenData.bgm}
                onPlay={this.audioPlay}
                onPause={this.audioPause}
                loop
              ></Audio>
            )} */}
            <img
              className="golden_cantaniner"
              src={
                goldenData.background ||
                'http://cdn.jisuapp.cn/static/webapp/images/goldenContainer.png'
              }
            />
            {goldenData.bgm != 0 && (
              <div
                className={'goldenMusic ' + (isPlay == true ? 'active' : '')}
                onClick={this.playMusics}
              >
                {isPlay == true && (
                  <span className="ico-moon icon-luckyMusic"></span>
                )}
                {isPlay == false && (
                  <span className="ico-moon icon-luckyMute"></span>
                )}
              </div>
            )}
            <div className="scatter">
              <img src="http://cdn.jisuapp.cn/static/webapp/images/goldenMotive.png" />
            </div>
            <div className="goldenHouse">
              <div className="goldenSinker" hidden={isSinker == true}>
                <img src="http://cdn.jisuapp.cn/static/webapp/images/goldenSinker.gif" />
              </div>
              <div className="goldenEgg">
                {eggsList.map((item, index) => {
                  return (
                    <div
                      onClick={this.startEgg}
                      key={index}
                      data-index={index}
                      className={'egg' + index}
                    >
                      <div
                        className={
                          'egg-gif ' + (isWin ? 'egg-win' : 'egg-notwin')
                        }
                        hidden={!item.hasAnimate}
                        data-index={index}
                      ></div>
                      <div className="egg-png" hidden={item.hasAnimate}></div>
                    </div>
                  )
                })}
                <img
                  src="http://cdn.jisuapp.cn/static/webapp/images/golden-eggs-win.png"
                  hidden={true}
                />
                <img
                  src="http://cdn.jisuapp.cn/static/webapp/images/golden-eggs-notwin.png"
                  hidden={true}
                />
              </div>
              <div className="activeData">
                <div
                  className="activepopNum"
                  style={convertLineStyleData(
                    'margin-top:' +
                    (goldenData.joined_show == -1 ? '35rpx' : '11rpx')
                  )}
                >
                  你有<span>{eggNum}</span>次砸蛋机会
                </div>
                {goldenData.joined_show != -1 && (
                  <div className="phone-personNum">
                    已有<span>{goldenData.joined_show}</span>人参加活动
                  </div>
                )}
              </div>
            </div>
            <div className="structurePrize">
              <div className="lookPrize" onClick={this.recordClick}>
                查看奖品
              </div>
              <div
                className="exchangePrize"
                onClick={this.exchangePrizeClick}
                style={convertLineStyleData(
                  'display:' +
                  (goldenData.integral_exchange == 0 ? 'none' : 'inline-block')
                )}
              >
                积分兑换
              </div>
            </div>
            <div className="golden-winner">
              <div className="winner-header">
                <span>中奖名单</span>
              </div>
              <div className="winner-content">
                {winnerList.length === 0 ? (
                  <div className="no-winner-list">暂无中奖名单</div>
                ) : (
                    <React.Fragment>
                      <div className="winner-list winner-list1" animation={animationData}>
                        {winnerList.map((item, index) => {
                          return (
                            <div key={index}>
                              <span>{item.nickname}</span>
                              <span>{item.prize_title}</span>
                            </div>
                          )
                        })}
                      </div>
                      <div className="winner-list winner-list2" animation={animationData2}>
                        {winnerList.map((item, index) => {
                          return (
                            <div key={index}>
                              <span>{item.nickname}</span>
                              <span>{item.prize_title}</span>
                            </div>
                          )
                        })}
                      </div>
                    </React.Fragment>
                  )}
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-header">
                <span>兑奖说明</span>
              </div>
              <div className="rule-content">
                <div className="rule-startTime">
                  开始时间：<span>{goldenData.start_time}</span>
                </div>
                <div className="rule-endTime">
                  结束时间：<span>{goldenData.end_time}</span>
                </div>
                <div className="rule-prizeMes">
                  <span>{goldenData.description}</span>
                </div>
                <div>获取砸金蛋次数：</div>
                {goldenData.user_times_initial > 0 && (
                  <div className="rule-goldenNum">
                    <label className="goldenDisc">·</label>用户每日首次登录可获取
                    <span>{goldenData.user_times_initial}</span>次砸金蛋机会。
                  </div>
                )}
                <div className="rule-most">
                  <label className="goldenDisc">·</label>每日砸金蛋机会最多为
                  <span>
                    {goldenData.user_times == '-1'
                      ? '无限'
                      : goldenData.user_times}
                  </span>
                  次。
                </div>
                {goldenData.integral_exchange != 0 && (
                  <div className="rule-exchanage">
                    <label className="goldenDisc">·</label>每
                    <span>{goldenData.integral_exchange}</span>
                    积分可兑换一次砸金蛋机会。
                  </div>
                )}
                {goldenData.time_share != 0 && (
                  <div className="rule-share">
                    <label className="goldenDisc">·</label>
                    每成功分享给1个好友可增加<span>{goldenData.time_share}</span>
                    次砸金蛋机会，最多可增加
                    <span>{goldenData.time_share_limit}</span>次机会。
                  </div>
                )}
                {goldenData.consume_money == 0 && goldenData.consume_times != 0 && (
                  <div>
                    <label className="goldenDisc">·</label>消费即赠送
                    <span>{goldenData.consume_times}</span>次砸金蛋机会。
                  </div>
                )}
                {goldenData.consume_money != 0 && (
                  <div>
                    <label className="goldenDisc">·</label>单次消费每满
                    <span>{goldenData.consume_money}</span>元，则赠送
                    <span>{goldenData.consume_times}</span>次砸金蛋机会，最多增加
                    <span>{goldenData.consume_times_limit}</span>次机会。
                  </div>
                )}
                <div style={convertLineStyleData('margin-top: 5px;')}>此活动最终解释权归本店所有;</div>
                <div>ps：优惠券奖品直接发放，可在小程序我的优惠券中查看。</div>
              </div>
            </div>
            {/*  积分兑换弹窗  */}
            {isExchange == 1 && (
              <div className="exchange">
                <div className="exchange-wrap">
                  <div className="exchange-con">
                    <div className="exchangeCan">
                      可兑换次数：<label>{exchangeMessage.exchange_times}</label>
                      <label>次</label>
                    </div>
                    <div className="exchangeLimit">
                      兑换次数：
                      <input
                        type="text"
                        onInput={this.bindReplaceInput}
                        value={inputValue}
                      />
                      <label className="exchangeAll" onClick={this.exchangeAll}>
                        全部兑换
                      </label>
                    </div>
                    <div className="exchangeRule">
                      兑换规则：<label>{exchangeMessage.integral_exchange}</label>
                      /次
                    </div>
                    <div className="exchangeBalance">
                      积分余额：<label>{exchangeMessage.can_use_integral}</label>
                      分
                    </div>
                  </div>
                  <div className="exchange-btns">
                    <div
                      className="exchange-cancel"
                      onClick={this.exchangeCancel}
                    >
                      取消
                    </div>
                    <div
                      className="exchange-confirm"
                      onClick={this.exchangeConfirm}
                    >
                      确定
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*  查看奖品弹窗   */}
            {isRecord == 1 && (
              <div className="golden-record" onClick={this.recordWrapClick}>
                <div className="record-wrap" onClick={this.stopPropagation}>
                  <div className="record-wrap-header">我的中奖记录</div>
                  <div className="record-wrap-edge">
                    <div className="record-wrap-con">
                      <div className="record-wrap-title">
                        <div className="record_line"></div>
                        <span>中奖时间</span>
                        <span>获得奖品</span>
                      </div>
                      <div className="record-list" hidden={myPrize == ''}>
                        {myPrize.map((item, index) => {
                          return (
                            <div key={index}>
                              <span>{item.add_time}</span>
                              <span>{item.prize_title}</span>
                            </div>
                          )
                        })}
                      </div>
                      <div className="record_fail" hidden={myPrize != ''}>
                        <img src="http://cdn.jisuapp.cn/static/webapp/images/golden-fail.png" />
                        <div>暂未获得任何奖品哦~</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* 抽奖次数用完可以分享给好友弹窗 */}
            {duraMax == 1 && (
              <div className="duraMaxDiv">
                <div className="duraMaxDiv-wrap">
                  <div className="duraMaxDiv-con">
                    <div>
                      对不起,您的砸金蛋<label className="balance">次数不足</label>
                    </div>
                  </div>
                  <div className="duraMaxDiv-btns">
                    <div className="duraMaxDiv-cancel" onClick={this.duraClick}>
                      确定
                    </div>
                    <button className="duraMaxDiv-confirm" openType="share" onClick={this.shareClickEvent}>
                      获取更多
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/*  抽奖次数用完不可分享给好友弹窗  */}
            {isdegree == 1 && (
              <div className="degreeDiv">
                <div className="degreeDiv-wrap">
                  <div className="degreeDiv-con">
                    <div>
                      对不起,您的砸金蛋<label className="balance">次数不足</label>
                    </div>
                  </div>
                  <div className="degreeDiv-btns">
                    <div className="degreeDiv-cancel" onClick={this.degreeClick}>
                      取消
                    </div>
                    <div
                      className="degreeDiv-confirm"
                      onClick={this.degreeClick}
                    >
                      确定
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*  中奖弹窗  */}
            {congratulation == 1 && (
              <div className="Congratulations_sick" onClick={this.shadeClose}>
                <div className="Congratulations_wrap">
                  <div className="Congratulations-con">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/Congratulations.png" />
                    <label>{prize_title}</label>
                  </div>
                  <div className="Congratulations-btns">
                    {ifWxCoupon ? (
                      <button
                        className="btns Congratulations-confirm"
                        style={convertLineStyleData('margin-left: 112rpx;')}
                        onClick={this.toAddCard}
                      >
                        立即领取
                      </button>
                    ) : (
                        <button
                          className="btns Congratulations-confirm"
                          style={convertLineStyleData('margin-left: 112rpx;')}
                          onClick={this.confirmClick}
                        >
                          确定
                      </button>
                      )}
                    <button
                      className="btns Congratulations-share"
                      style={convertLineStyleData('margin-left: 58rpx;')}
                      openType="share"
                      onClick={this.shareClickEvent}
                    >
                      传达喜悦
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/*  未中奖弹窗  */}
            {prizeFail == 1 && (
              <div className="notwinning_sick">
                <div className="notwinning_wrap">
                  <div className="notwinning_title">
                    未中奖<div className="conBefore"></div>
                    <div className="conAfter"></div>
                  </div>
                  <div className="notwinning_con">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/notWinning.png" />
                    <div>很遗憾！</div>
                    <div>您什么都没砸中哦~</div>
                  </div>
                  <div className="notwinning_btns">
                    <button
                      className="push notwinning_confirm"
                      onClick={this.notwinningClick}
                    >
                      确定
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/*  安慰奖弹窗  */}
            {comfort == 1 && (
              <div className="consolation_sick" onClick={this.shadeClose}>
                <div className="consolation_wrap">
                  <div className="consolation_title">
                    安慰奖<div className="conBefore"></div>
                    <div className="conAfter"></div>
                  </div>
                  <div className="consolation_con">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/consolation.png" />
                    {ifGetComfort ? (
                      <div className="comfortText">
                        已领取，在微信卡包中查看哦~
                      </div>
                    ) : (
                        <div className="comfortText" className="comfortText">
                          又没中奖，送你一个小礼品
                      </div>
                      )}
                    {!ifWxCoupon && !ifGetComfort && (
                      <div className="comfortText">
                        >在优惠券卡包进行查收哦~
                      </div>
                    )}
                  </div>
                  {ifWxCoupon ? (
                    <div className="comfortCouponBtn">
                      <button
                        className="push consolation_confirm"
                        onClick={this.shadeClose}
                      >
                        确定
                      </button>
                      <button
                        className="push consolation_share"
                        onClick={this.toAddCard}
                      >
                        立即领取
                      </button>
                    </div>
                  ) : (
                      <div className="consolation_btns">
                        <button
                          className="push consolation_confirm"
                          onClick={this.comfortClick}
                        >
                          确定
                      </button>
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/golden-eggs/GoldenEggs.jsx